var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmpty6 = function SvgEmpty6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 708,
    height: 200,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE5",
    d: "M457.165 155.15a3.226 3.226 0 0 0 3.227-3.226V56.258h-27.464a3.227 3.227 0 0 1-3.227-3.227V25.567h-64.975a3.226 3.226 0 0 0-3.226 3.227v123.13a3.226 3.226 0 0 0 3.226 3.226z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#66C2E0",
    d: "M361.5 151.924V28.794a3.226 3.226 0 0 1 3.226-3.227h46.22v129.767l-46.22-.184a3.226 3.226 0 0 1-3.226-3.226"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3E0F0",
    d: "m460.392 56.258-30.691-30.69V53.03a3.227 3.227 0 0 0 3.227 3.227z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#99D6EB",
    d: "M429.885 175.611a3.227 3.227 0 0 0 3.227-3.227V76.719h-27.464a3.226 3.226 0 0 1-3.227-3.227V46.028h-64.975a3.227 3.227 0 0 0-3.227 3.227v123.129a3.227 3.227 0 0 0 3.227 3.227z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE5",
    d: "M334.219 172.384V49.254a3.227 3.227 0 0 1 3.227-3.226h46.219V175.61h-46.219a3.227 3.227 0 0 1-3.227-3.227"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCEBF5",
    d: "m433.112 76.719-30.691-30.691v27.464a3.226 3.226 0 0 0 3.227 3.227z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D7E",
    d: "m395.733 152-.001 35.662c0 .861.944 1.374 1.663.923l9.418-5.905a2.19 2.19 0 0 1 2.339 0l9.419 5.905a1.086 1.086 0 0 0 1.662-.923l.001-35.662c-8.167.033-16.334 0-24.501 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000046",
    fillRule: "evenodd",
    d: "M407.984 143.249c-5.8 0-10.501 4.701-10.501 10.5s4.701 10.501 10.501 10.501 10.5-4.701 10.5-10.501-4.701-10.5-10.5-10.5m-17.501 10.5c0-9.665 7.835-17.501 17.501-17.501 9.665 0 17.501 7.836 17.501 17.501s-7.836 17.501-17.501 17.501-17.501-7.835-17.501-17.501",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3E0F0",
    d: "M407.983 164.25c-5.8 0-10.501-4.701-10.501-10.5s4.701-10.501 10.501-10.501 10.5 4.701 10.5 10.501-4.701 10.5-10.5 10.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2A84D",
    d: "M366.569 31.059C366.569 13.928 352.641 0 335.51 0h-59.506c-17.131 0-31.059 13.928-31.059 31.059v27.863l-14.391 14.46h-.064c-1.226 1.307-2.142 3.154-2.156 5.339a7.9 7.9 0 0 0 2.287 5.55l14.324 14.324v70.346c0 17.131 13.928 31.059 31.059 31.059h59.506c17.131 0 31.059-13.928 31.059-31.059z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC8200",
    d: "M366.569 31.059C366.569 13.928 352.641 0 335.51 0h-29.753v200h29.753c17.131 0 31.059-13.928 31.059-31.059z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000046",
    fillRule: "evenodd",
    d: "M304.804 42.155a5.88 5.88 0 0 0-5.882 5.882 8.234 8.234 0 0 1-16.468 0 5.882 5.882 0 1 0-11.764 0c0 11.045 8.953 19.999 19.998 19.999s19.999-8.954 19.999-19.999a5.883 5.883 0 0 0-5.883-5.882M310.686 86.043a5.88 5.88 0 0 0-5.882 5.882c0 18.088-14.042 32.353-30.882 32.353a5.883 5.883 0 1 0 0 11.765c23.768 0 42.647-19.972 42.647-44.118a5.883 5.883 0 0 0-5.883-5.882",
    clipRule: "evenodd"
  })));
};
export default SvgEmpty6;